import { useEffect } from 'react'
import { isAuthStorageKey } from '../authPersistence'

type ClearAuthStateFn = (input?: { clearStorage?: boolean; broadcast?: boolean }) => void

export const useCustomerAuthStorageSync = ({
  bootstrapFromSession,
  clearAuthState,
}: {
  bootstrapFromSession: () => Promise<void>
  clearAuthState: ClearAuthStateFn
}) => {
  useEffect(() => {
    const syncFromStorage = () => {
      void bootstrapFromSession().catch(() => {
        clearAuthState({ clearStorage: false, broadcast: false })
      })
    }

    const onStorage = (event: StorageEvent) => {
      if (isAuthStorageKey(event.key)) {
        syncFromStorage()
      }
    }

    window.addEventListener('storage', onStorage)
    return () => {
      window.removeEventListener('storage', onStorage)
    }
  }, [bootstrapFromSession, clearAuthState])
}
